import FadeSceneTransition from "./scene/fade-scene-transition";
import FadeAudioTransition from "./audio/fade-audio-transition";
import DetuneAudioTransition from "./audio/detune-audio-transition";
import MenuFadeTransition from "./menu/menu-fade-transition";
import MenuFadeScaleTransition from './menu/menu-fade-scale-transition';

const Transitions = <const> {
    Scene: {
        'fade': FadeSceneTransition
    },
    Menu: {
        'fade': MenuFadeTransition,
        'fade-scale': MenuFadeScaleTransition
    },
    Audio: {
        'fade': FadeAudioTransition,
        'detune': DetuneAudioTransition
    }
}

export default Transitions;